import { useTour } from '@reactour/tour';
import { useHistory } from 'react-router-dom';
import Button from 'src/componentes/button';
import { capitalizeFirstLetter } from 'src/utils/string';
import { useIntl } from 'react-intl';
import ReactGA from 'react-ga4';
import useAuth from 'src/hooks/useAuth';

function TourController({
  setOpenHelp,
  redirectPath,
  steps,
  tourName,
  onClose,
  ehProactiveTour = false,
}) {
  const { setIsOpen, setCurrentStep, setSteps } = useTour();
  const history = useHistory();
  const intl = useIntl();
  const { user } = useAuth();

  const handleClick = () => {
    if (tourName) {
      const eventGA = `Tour iniciado: ${tourName}`;
      ReactGA.event(eventGA, {
        category: 'onboarding',
        action: tourName,
        label: user?.nome,
      });
    }

    if (setOpenHelp) {
      setOpenHelp(false);
    }

    history.push(redirectPath);
    setSteps(steps);
    setIsOpen(true);
    setCurrentStep(0);

    if (onClose) {
      onClose();
    }
  };

  return (
    <Button
      className="tour-button"
      onClick={handleClick}
      style={{
        backgroundColor: ehProactiveTour ? '#f8f9fa' : undefined,
        color: ehProactiveTour ? '#1d7789' : undefined,
        border: ehProactiveTour ? '1px solid #f8f9fa' : undefined,
        fontWeight: 'bold',
      }}
    >
      {capitalizeFirstLetter(intl.formatMessage({ id: 'iniciar' }))}
    </Button>
  );
}

export default TourController;
